<app-back-to-integrations-button></app-back-to-integrations-button>
<div class="page-content">
	<div>
		<img src="/assets/images/integrations/chicago-title-logo.svg" />
	</div>
	<div>
		<h2>Chicago Title</h2>
		<p class="mt-5">
			Order title insurance from this industry leading provider without leaving
			Closer.
		</p>
		<div class="flex justify-between gap-2 mt-5" *ngIf="connected">
			<div class="flex gap-2 items-center">
				<div class="w-2 h-2 bg-green rounded-full"></div>
				<span class="text-green">Connected</span>
			</div>
			<p>
				<span class="text-sm">Default firm name: </span>
				<span class="font-bold">{{ chicagoLawfirm }}</span>
			</p>

			<div class="flex gap-1" *ngIf="(officeCount$ | async) > 1">
				<app-anchor (click)="openOfficeOverridesModal()"
					>Manage office overrides
				</app-anchor>
				<app-icon
					[icon]="ICON.WARNING"
					class="text-orange"
					*ngIf="(addressesWithChicagoOverrideCount$ | async) > 0"
					[matTooltip]="
						(addressesWithChicagoOverrideCount$ | async) +
						' office(s) overridden'
					"
				></app-icon>
			</div>
		</div>
		<div class="flex mt-5" *ngIf="!connected">
			<app-button btn="primary" class="mr-5" (click)="connect()" size="small"
				>Connect</app-button
			>
			<app-anchor [external]="true" url="https://chicagotitle.ca/"
				>Learn more</app-anchor
			>
		</div>
		<app-profile-benefits [benefits]="benefits"></app-profile-benefits>
	</div>
	<div>
		<app-container title="Resources" type="dark">
			<div class="text-sm flex flex-col gap-2">
				<a
					class="flex gap-2"
					externalNavInterceptor
					href="https://express.ctic.ca/clients/default.aspx?LANG=en-CA"
					target="_blank"
					title="Home & toots"
				>
					<app-icon [icon]="ICON.PERSON"></app-icon>
					<div class="flex flex-col">
						<span class="font-bold">My profile</span>
						<span class="text-gray-400">View my Chicago Title profile.</span>
					</div>
				</a>
				<a
					class="border-t-2 border-grey-lighter pt-4 m-2 flex flex-col items-center"
					externalNavInterceptor
					href="https://express.ctic.ca/clients/default.aspx?LANG=en-CA"
					target="_blank"
					title="Enroll now"
				>
					<p>New to Chicago Title?</p>
					<app-button [icon]="ICON.EXTERNAL" size="small"
						>Enroll now</app-button
					>
				</a>
			</div>
		</app-container>
		<div
			class="rounded-md border border-grey-lighter w-64 max-w-fit mt-8 bg-white"
		>
			<div class="flex justify-between items-center m-5">
				<p class="text-2xl font-bold">Contact info</p>
				<app-icon
					*ngIf="contact"
					[icon]="ICON.EDIT"
					class="text-lg cursor-pointer"
					(click)="openContactInfo()"
				></app-icon>
			</div>
			<div
				class="flex gap-2 ml-2 items-center my-5 font-bold p-5 cursor-pointer"
				(click)="openContactInfo()"
				*ngIf="!contact"
			>
				<app-icon [icon]="ICON.ADD"></app-icon>
				<p>Add main contact</p>
			</div>
			<div *ngIf="contact" class="px-5">
				<p class="font-bold text-lg">{{ contact.name }}</p>
				<p class="text-grey-lighter text-xs">{{ contact.title }}</p>
				<div class="text-sm flex flex-col gap-2 mb-4">
					<div class="flex gap-2" *ngIf="contact.phone">
						<app-icon class="text-grey-lighter" [icon]="ICON.PHONE"></app-icon>
						<p>{{ contact.phone }}</p>
					</div>
					<div class="flex gap-2" *ngIf="contact.email">
						<app-icon class="text-grey-lighter" [icon]="ICON.EMAIL"></app-icon>
						<p>{{ contact.email }}</p>
					</div>
				</div>
			</div>
			<hr class="w-full my-4 text-grey-lighter" />
			<div class="flex gap-2 px-5 mb-2">
				<app-icon class="text-green" [icon]="ICON.BUILDING"></app-icon>
				<p class="font-bold">Chicago Title Insurance Company</p>
			</div>
			<div class="text-sm px-5 flex flex-col gap-2 mb-4">
				<div class="flex gap-2">
					<app-icon class="text-grey-lighter" [icon]="ICON.LOCATION"></app-icon>
					<p>55 Superior Boulevard, Mississauga, ON L5TT 2X9</p>
				</div>
				<div class="flex gap-2">
					<app-icon class="text-grey-lighter" [icon]="ICON.PHONE"></app-icon>
					<p>(888) 868 4853</p>
				</div>
				<div class="flex gap-2">
					<app-icon class="text-grey-lighter" [icon]="ICON.FAX"></app-icon>
					<p>(888) 214-1953</p>
				</div>
			</div>
		</div>
	</div>
	<div class="text-sm px-5 flex flex-col gap-2 mb-4">
		<div class="flex gap-2">
			<app-icon class="text-grey-lighter" [icon]="ICON.LOCATION"></app-icon>
			<p>55 Superior Boulevard, Mississauga, ON L5T 2X9</p>
		</div>
		<div class="flex gap-2">
			<app-icon class="text-grey-lighter" [icon]="ICON.PHONE"></app-icon>
			<p>(888) 868 4853</p>
		</div>
		<div class="flex gap-2">
			<app-icon class="text-grey-lighter" [icon]="ICON.FAX"></app-icon>
			<p>(888) 214-1953</p>
		</div>
	</div>
</div>
